import { Injectable } from '@angular/core';
import { ValidationResult } from '../models/validation-result.model';

@Injectable({
  providedIn: 'root'
})
export class ZipCodeValidatorService {

    private postalCodeRegexPattern: RegExp = /^[0-9]{5}$/;
    private formatErrorMessage    : string = 'Formato del código postal no válido';

    constructor() { }

    public validate(postalCode: string) : ValidationResult {

        let result = new ValidationResult();

        // Converts to lowercase.
        postalCode = postalCode?.toString().toUpperCase();

        // Checks format.
        let isCorrectFormat = this.postalCodeRegexPattern.test(postalCode);
            isCorrectFormat ? result.setValidResult() : result.setInvalidResult(this.formatErrorMessage);

        return result;

    }

}
